/** 权限ID */
export var PermissionId = /*#__PURE__*/function (PermissionId) {
  PermissionId[PermissionId["InvalidPerm"] = 0] = "InvalidPerm";
  PermissionId[PermissionId["ViewFile"] = 102] = "ViewFile";
  PermissionId[PermissionId["EditFile"] = 103] = "EditFile";
  PermissionId[PermissionId["CopyFile"] = 105] = "CopyFile";
  PermissionId[PermissionId["DumpFile"] = 106] = "DumpFile";
  PermissionId[PermissionId["PrintFile"] = 111] = "PrintFile";
  return PermissionId;
}({});

/** 要查询权限的目标对象 */

export var PermissionDocType = /*#__PURE__*/function (PermissionDocType) {
  PermissionDocType[PermissionDocType["File"] = 2] = "File";
  PermissionDocType[PermissionDocType["Folder"] = 3] = "Folder";
  return PermissionDocType;
}({});
//# sourceMappingURL=permissions.js.map